import React, { useState } from 'react';
import UserSelect from '../../components/UserSelect';
import FileUploadSection from '../../components/FileUploadSection';
import { formatToJST } from '../../utils/dateFormatter';
import { RESUME_NOT_EXTRACTED_NOTICE, isResumeTextMissing } from '../../services/resumeApi';

/**
 * 読み取れなかった履歴書に注記を出す (Issue #1057)。
 *
 * text_extracted が無い応答 (本項目より前の BE) では判定せず、注記を出さない
 * (isResumeTextMissing。項目の不在を false と解釈すると全件に注記が出る)。
 */
const getResumeNotice = (attachment) =>
    (isResumeTextMissing(attachment) ? RESUME_NOT_EXTRACTED_NOTICE : null);

const BasicInfoTab = ({
    opportunity,
    isEditing,
    editData,
    handleEditDoubleClick,
    handleEditChange,
    opportunityId,
    onOpenResumeReviewModal,
    resumeReviewLoading
}) => {
    const [hasResumeFiles, setHasResumeFiles] = useState(false);
    return (
        <div className="detail-single-column-container">
            <div className="detail-item-group">
                <div className="detail-section-header">案件基本情報</div>

                <div className="detail-item" onDoubleClick={handleEditDoubleClick}>
                    <span className="detail-label">担当者</span>
                    {isEditing ? (
                        <UserSelect
                            value={editData.owner_id}
                            onChange={(val) => handleEditChange('owner_id', val)}
                            placeholder="担当者を選択..."
                        />
                    ) : (
                        <span className="detail-value">{opportunity.owner_name}</span>
                    )}
                </div>
            </div>

            <div className="detail-item-group">
                <div className="detail-section-header" style={{ justifyContent: 'space-between' }}>
                    <span>職務経歴、履歴書</span>
                    {!isEditing && (
                        <button
                            className="btn-ai-generate"
                            onClick={onOpenResumeReviewModal}
                            disabled={resumeReviewLoading || !hasResumeFiles}
                            title={!hasResumeFiles ? "生成には履歴書ファイルのアップロードが必要です" : ""}
                        >
                            <span className="ai-icon">✨</span> AIレビュー生成
                        </button>
                    )}
                </div>

                <div className="detail-item" onDoubleClick={handleEditDoubleClick}>
                    <span className="detail-label">求職者情報</span>
                    {isEditing ? (
                        <textarea
                            className="detail-value-textarea"
                            rows="10"
                            placeholder="(求職者情報が未設定です。求職者情報や職務経歴書の内容をこちらに入力いただくと、AIによる面談の事前準備が可能です。)"
                            value={editData.profile}
                            onChange={(e) => handleEditChange('profile', e.target.value)}
                        />
                    ) : (
                        <span className="detail-value-pre">
                            {opportunity.profile || '(求職者情報が未設定です。求職者情報や職務経歴書の内容をこちらに入力いただくと、AIによる面談の事前準備が可能です。)'}
                        </span>
                    )}
                </div>

                {/* 求職者履歴書 (編集モード以外で表示) */}
                {!isEditing && (
                    <FileUploadSection
                        uploadUrlEndpoint={`/opportunities/${opportunityId}/resume/upload_url`}
                        confirmEndpoint={`/opportunities/${opportunityId}/resume/confirm`}
                        getEndpoint={`/opportunities/${opportunityId}/resume`}
                        deleteEndpoint={`/opportunities/${opportunityId}/resume`}
                        label="求職者履歴書"
                        accept="application/pdf,text/plain,text/csv,.txt,.csv"
                        maxFileSizeMB={10}
                        multiFile={true}
                        maxFileCount={3}
                        maxTotalSizeMB={15}
                        onAttachmentChange={(files) => setHasResumeFiles(files && files.length > 0)}
                        getAttachmentNotice={getResumeNotice}
                    />
                )}
            </div>

            <div className="detail-item-group">
                <div className="detail-section-header">システム情報</div>
                <div className="detail-item">
                    <span className="detail-label">作成日時</span>
                    <span className="detail-value">
                        {opportunity.created_at ? formatToJST(opportunity.created_at) : ''}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default BasicInfoTab;
